import { TransactionMode } from 'app/types/listing';
import type { ListingSubtype } from 'app/types/listing';
import type { Address } from 'app/types/address';
import type { Group } from 'app/types/group';

export const DEFAULT_TRANSACTION_MODES = [TransactionMode.lend, TransactionMode.give, TransactionMode.sell];

interface AvailableFilterValues {
  addresses?: Pick<Address, 'id'>[];
  groups?: Pick<Group, 'id'>[];
  subtypes: ListingSubtype[];
}

export function getDefaultFilterValues(availableValues: AvailableFilterValues) {
  return {
    selectedAddresses: availableValues.addresses?.map((address) => address.id) ?? [],
    selectedGroups: availableValues.groups?.map((group) => group.id) ?? [],
    selectedCategories: [],
    selectedServiceCategories: [],
    selectedSubtypes: availableValues.subtypes,
    selectedTags: [],
    hideFoundRequests: false,
    dismissedOnly: false,
    hideOffersWithFee: false,
    selectedTransactionModes: [...DEFAULT_TRANSACTION_MODES],
  } satisfies {
    selectedAddresses: string[];
    selectedGroups: string[];
    selectedCategories: string[];
    selectedServiceCategories: string[];
    selectedSubtypes: ListingSubtype[];
    selectedTags: string[];
    hideFoundRequests: boolean;
    dismissedOnly: boolean;
    hideOffersWithFee: boolean;
    selectedTransactionModes: TransactionMode[];
  };
}

export function applyDefaultFilterValues(
  availableValues: AvailableFilterValues,
  searchDistance: number | undefined,
  setFilters: (filters: ReturnType<typeof getDefaultFilterValues> & { searchDistance?: number }) => void,
) {
  const defaults = getDefaultFilterValues(availableValues);
  setFilters({ ...defaults, searchDistance });
  return defaults;
}
